import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch { /* always show the same result */ }
    setLoading(false); setSent(true);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-[#12141a] border border-zinc-800 rounded-2xl p-8" data-testid="forgot-card">
        {sent ? (
          <div data-testid="forgot-sent">
            <MailCheck size={36} className="text-[#10b981]" />
            <h1 className="font-display text-2xl font-extrabold text-white mt-3">Check your inbox</h1>
            <p className="text-zinc-400 text-sm mt-2">If an account exists for <span className="text-white">{email}</span>, we've emailed a link to choose a new password. It works once and expires in 1 hour.</p>
            <p className="text-zinc-500 text-xs mt-4">Nothing after a few minutes? Check spam, or <button onClick={() => setSent(false)} className="text-[#ff6a13] hover:underline" data-testid="forgot-again">try again</button>.</p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-extrabold text-white">Forgot password?</h1>
            <p className="text-zinc-400 text-sm mt-1">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div>
                <Label className="text-zinc-300">Email</Label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="you@email.com" />
              </div>
              <Button data-testid="forgot-submit" disabled={loading} type="submit" className="w-full bg-[#ff6a13] hover:bg-[#ff8a3d] text-white rounded-full h-11 font-semibold">{loading ? "Sending…" : "Send reset link"}</Button>
            </form>
          </>
        )}
        <p className="text-sm text-zinc-500 mt-6 text-center"><Link to="/login" className="text-[#ff6a13] hover:underline" data-testid="back-to-login">Back to sign in</Link></p>
      </div>
    </div>
  );
}
